import React, { forwardRef } from "react";

export const TableContainer = forwardRef(({ children, className, style, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={`table-responsive ${className || ""}`}
      style={{
        display: "flex",
        flexDirection: "column",
        flex: "1 1 0",
        overflow: "auto",
        border: "1px solid var(--tblr-border-color, #e0e0e0)",
        borderRadius: "4px",
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
});
